import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Home as HomeIcon, Briefcase, ShieldCheck, Wallet, Scale, HeartPulse, TrendingUp, PiggyBank, Building2, Landmark, ArrowRight } from "lucide-react";
import BenchmarkBanner from "@/components/marketing/BenchmarkBanner";
import SectorCTA from "@/components/marketing/SectorCTA";

const ICONS = {
  Home: HomeIcon, Briefcase, ShieldCheck, Wallet, Scale, HeartPulse, TrendingUp, PiggyBank, Building2, Landmark,
};

export default function Sectors() {
  const [sectors, setSectors] = useState([]);
  useEffect(() => { api.get("/catalog/sectors").then(r => setSectors(r.data)); }, []);
  return (
    <div>
      <section className="relative border-b border-slate-200 overflow-hidden">
        <div className="absolute inset-0 dot-grid dot-grid-fade opacity-70" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 lg:py-24">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-primary">Sectors</p>
          <h1 className="mt-3 text-5xl sm:text-6xl tracking-[-0.04em] font-semibold text-slate-900 max-w-3xl">Ten financial verticals. One operational standard.</h1>
          <p className="mt-5 max-w-2xl text-lg text-slate-600">Every sector ships with its own compliance scripts, qualification logic, buyer panel and pricing tiers — operated under one platform.</p>
        </div>
      </section>

      <section className="py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {sectors.map((s) => {
            const Icon = ICONS[s.icon] || HomeIcon;
            return (
              <Link key={s.slug} to={`/sectors/${s.slug}`} className="group rounded-2xl border border-slate-200 bg-white p-6 hover:border-primary/40 hover:shadow-float transition-all" data-testid={`sector-card-${s.slug}`}>
                <div className="flex items-center justify-between">
                  <span className="inline-grid place-items-center size-10 rounded-lg bg-slate-900 text-white"><Icon className="size-5" strokeWidth={1.6} /></span>
                  <span className="text-xs font-mono text-slate-400">CXG · {s.slug.toUpperCase()}</span>
                </div>
                <h3 className="mt-5 text-xl font-medium tracking-tight text-slate-900">{s.name}</h3>
                <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{s.tagline}</p>
                <div className="mt-5 flex items-center justify-between text-xs">
                  <span className="text-slate-500">Volume <span className="font-medium text-slate-800">{s.volume_band}</span></span>
                  <span className="text-slate-500">From <span className="font-medium text-slate-800">£{s.base_cpl}</span></span>
                </div>
                <div className="mt-5 inline-flex items-center gap-1 text-sm text-primary">Sector detail <ArrowRight className="size-3.5" /></div>
              </Link>
            );
          })}
        </div>
      </section>

      <SectorCTA />

      <BenchmarkBanner />
    </div>
  );
}
